import React from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import strings from 'strings';
import FPActionButton from 'UI/components/atoms/FPActionButton';
import { SvgCommonFileTextAdd, SvgNewFolderIcon } from 'UI/res';

import TemplatesTreeView from '../TemplateTreeView';

import { useStyles } from './styles';

const { tooltipText, actions } = strings.bulkEmails.templateActions;

/**
 * @param {Object} props
 * @param {boolean} [props.isAllowedToCreate]
 * @param {Function} props.onOpenFolderDrawer
 * @param {Function} props.onOpenTemplateDrawer
 * @param {TemplatesTreeViewPropTypes} [props.TemplatesTreeViewProps]
 */
const TemplateTreeViewList = ({
  isAllowedToCreate = false,
  onOpenFolderDrawer,
  onOpenTemplateDrawer,
  TemplatesTreeViewProps = {}
}) => {
  const classes = useStyles();

  const btnSharedProps = {
    className: classes.actionButton,
    variant: 'text',
    disabled: !isAllowedToCreate
  };

  return (
    <Grid container direction="column" className={classes.root}>
      <Tooltip title={!isAllowedToCreate ? tooltipText : ''} arrow placement="top">
        <Grid container item className={classes.buttonsWrapper}>
          <Grid item xs={6}>
            <FPActionButton
              {...btnSharedProps}
              text={actions.newFolder}
              onClick={onOpenFolderDrawer}
              icon={SvgNewFolderIcon}
            />
          </Grid>
          <Grid item xs={6}>
            <FPActionButton
              {...btnSharedProps}
              text={actions.newTemplate}
              onClick={onOpenTemplateDrawer}
              icon={SvgCommonFileTextAdd}
            />
          </Grid>
        </Grid>
      </Tooltip>
      <Grid item className={classes.templatesTreeWrapper}>
        <TemplatesTreeView {...TemplatesTreeViewProps} />
      </Grid>
    </Grid>
  );
};

export default TemplateTreeViewList;
